import { render, staticRenderFns } from "./signaturePad.vue?vue&type=template&id=4937fa4c&scoped=true"
import script from "./signaturePad.vue?vue&type=script&lang=js"
export * from "./signaturePad.vue?vue&type=script&lang=js"
import style0 from "./signaturePad.vue?vue&type=style&index=0&id=4937fa4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937fa4c",
  null
  
)

export default component.exports